import React from 'react';
import ReactDOM from 'react-dom';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { getUserInfo } from '../utils';
import { rewriteRequestHeaders, rewriteRequestParams /* rewriteRequestFormdata */ } from '../utils/check';
import http from './axios';

const rewriteOBJ = (o, bashURL) => {
  Object.keys(o).forEach((key) => {
    const method = key;
    Object.keys(o[method]).forEach((alias) => {
      const URL = o[method][alias];
      o[method][alias] = (data, config) => {
        const rewriteData = rewriteParams(data);
        const { headers, params } = rewriteData;
        const newHead = rewriteRequestHeaders(headers);
        const newParams = rewriteRequestParams(params);
        return http[method.toLowerCase()](bashURL + URL, newParams, { headers: { ...newHead, ...config } });
      };
    });
  });
};

/**
 * 创建一个保留 x-WardId header 的请求方法。
 * 默认 rewriteOBJ 会根据角色裁剪请求头，Hospital Admin / PRO / SA 之类角色会移除 x-WardId。
 * 某些接口即使在这些角色下也必须带上 x-WardId 时，可以直接复用这个 helper，
 * 避免把模块级特殊规则继续堆到 rewriteOBJ 里。
 */
const createRequestWithWardIdHeader = (method, bashURL, url) => {
  return (data, config) => {
    const rewriteData = rewriteParams(data);
    const { headers, params } = rewriteData;
    const newParams = rewriteRequestParams(params);
    return http[method.toLowerCase()](bashURL + url, newParams, { headers: { ...headers, ...config } });
  };
};

const rewriteNewOBJ = (o, bashURL) => {
  Object.keys(o).forEach((key) => {
    const method = key;
    Object.keys(o[method]).forEach((alias) => {
      const URL = o[method][alias];
      o[method][alias] = (data, config) => {
        const rewriteData = rewriteParams(data);
        const { headers, params } = rewriteData;
        const newHead = rewriteRequestHeaders(headers);
        const newParams = rewriteRequestParams(params);
        return http[method.toLowerCase()](bashURL + URL, newParams, { ...config, headers: { ...newHead } });
      };
    });
  });
};

const rewriteParams = (params) => {
  const XIds = getUserInfo();
  const HospitalId = XIds.hospId;
  const WardId = XIds.wardId;
  if (params?.['x-HospitalId']) {
    delete params['x-HospitalId'];
  }
  if (params?.['x-WardId']) {
    delete params['x-WardId'];
  }
  return {
    headers: {
      'x-HospitalId': HospitalId || '',
      'x-WardId': WardId || '',
    },
    params,
  };
};

const rewriteHeaderIdByUserRole = () => {
  // Super Administrator (roleTypeId = 1 ): x-HospitalId 和 x-WardId 都为null
  // Hospital Administrator (roleTypeId = 2 ): x-HospitalId 正常传, x-WardId都为null
  // PRO Admin (roleTypeId = 7 ): x-HospitalId 正常传, x-WardId都为null
  // 其他角色: x-HospitalId 和 x-WardId 都正常传
  const userInfo = getUserInfo();
  if (!userInfo) return { HospitalId: null, WardId: null };
  const roleTypeId = userInfo?.roleTypeId ?? '';
  const HospitalId = roleTypeId === 1 ? null : userInfo.hospId;
  const WardId = [1, 2, 7].includes(roleTypeId) ? null : userInfo.wardId;

  return {
    'x-HospitalId': HospitalId,
    'x-WardId': WardId,
  };
};

const ResponseCommCodeEnum = {
  SUCCESS: '0',
  SERVER_IS_BUSY: '9999',
  API_NOT_EXITS: '9997',
  TOKEN_ERROR: '9100',
  USER_INACTIVE: '9204',
  BED_VERSION: '6400',
  SETTING_TV_ROBOT: '5009',
  SETTING_TV_ROBOT_NAME: '5010',
  ADS_SERVICE_EXCEPTION: '4984',
  DUTYASSIGN_UPLOADED_FAIL: '7312',
  DUTYASSIGN_UPLOADED_ERROR: '7309',
  DUTYASSIGN_UPLOADED_NO_CORPID: '7310',
  EQUIPMENT_DUPLICATE_REQUEST: '4900',
  CHECK_SERVER: '3600',
  SCAN_HKID: '4902',
  EHD_HA_CHAT_MESSAGE_STILL_SENDING:'8899',
  EHANDOVER_UPLOAD_DOC_PAGE_EXCEEDED:'8501'
};

const alertMsg = (msg, ID, type = 'error', timeout = null, autoClose = true) => {
  const alertEl = document.createElement('div');
  alertEl.setAttribute('id', ID);
  document.getElementById('root').appendChild(alertEl);
  ReactDOM.render(
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={() => {
        autoClose && closeAlert(ID);
      }}
      autoHideDuration={timeout}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={() => {
          closeAlert(ID);
        }}
        severity={type}
      >
        {msg}
      </MuiAlert>
    </Snackbar>,
    alertEl
  );
};

const closeAlert = (ID) => {
  const targetEl = document.getElementById(ID);
  targetEl?.remove();
};

export {
  rewriteOBJ,
  rewriteNewOBJ,
  createRequestWithWardIdHeader,
  ResponseCommCodeEnum,
  alertMsg,
  rewriteParams,
  rewriteHeaderIdByUserRole,
};
